module.exports = __webpack_public_path__ + "img/off-agility.bae6fa00.png";